/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable func-style */
import { Unsubscribable } from 'rxjs';
export type paramsType = {
    /*
    default value : ngOnDestroy
    */
    destroyFunc?: string;
};

export interface InstanceSubscriptionWithInstance {
    instance: any;
    subscription: Unsubscribable;
}

export function DestroySubscribers(params?: paramsType) {
    return function (target) {
        params = {
            destroyFunc: 'ngOnDestroy',
            ...params,
        };
        const unsubscribableLike: { subscriptions: Unsubscribable[]; unsubscribe: () => void } = {
            subscriptions: [],
            unsubscribe,
        };
        //const subscriber: string = Reflect.getMetadata('subscription:name', target.prototype, 'subscriber');

        Object.defineProperty(target.prototype, 'subscriber', {
            get: () => unsubscribableLike,
            set: subscription => unsubscribableLike.subscriptions.push(subscription),
        });

        if (typeof target.prototype[params.destroyFunc] != 'function') {
            throw new Error(
                `${target.prototype.constructor.name} must implement ${params.destroyFunc}() lifecycle hook`
            );
        }

        target.prototype[params.destroyFunc] = ngOnDestroyDecorator(target.prototype[params.destroyFunc]);

        function ngOnDestroyDecorator(f) {
            return function () {
                unsubscribe.call(this);
                console.log('Destroy call');
                // eslint-disable-next-line prefer-rest-params
                return f.apply(this, arguments);
            };
        }

        function unsubscribe() {
            do {
                const sub: Unsubscribable = unsubscribableLike.subscriptions.shift();
                if (sub && typeof sub.unsubscribe === 'function') {
                    console.log('unsubscribed...[OK]');
                    sub.unsubscribe();
                }
            } while (unsubscribableLike.subscriptions.length);
        }

        return target;
    };
}

// eslint-disable-next-line func-style
// @CombineSubscriptions() - implement this Decorator
// in case you want to change the default variable's name("subscriber") of a subscription,
// otherwise don't apply it.
export function CombineSubscriptions(_params?) {
    return function (target, propertyKey: string | symbol) {
        if (propertyKey != 'subscriber') {
            //Reflect.defineMetadata('subscription:name', propertyKey, target, 'subscriber');
        }
    };
}
